import 'swiper/swiper-bundle.css'

import { Global } from '@emotion/react'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import { QueryClientProvider } from '@tanstack/react-query'
import { domAnimation, LazyMotion } from 'framer-motion'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { ToastContainer } from 'react-toastify'

import queryClient from '~/@common/queryClient'
import { commonRepo } from '~/@common/services/repo.service'
import { globalCss } from '~/@common/styles/globalCss.ts'
import { envUtils } from '~/@common/utils/envUtils'
import { testUtils } from '~/@common/utils/testUtils'
import { LastLocationManager } from '~/@pages/@common/index.ts'

import { appRouter } from './appRouter.tsx'
import { initI18n } from './i18n.ts'
import { initialize } from './init/initialize.ts'

domainProvider.debugging({ isLiveEnv: envUtils.isLive })

if (!envUtils.isLive) {
  testUtils.initialize()
}

initialize()
  .then(() => initI18n(commonRepo.academy?.languagePackFileUrl))
  .then(() => {
    ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
      <>
        <Global styles={globalCss} />
        <QueryClientProvider client={queryClient}>
          <LazyMotion features={domAnimation} strict>
            <LastLocationManager.Provider value={new LastLocationManager.Service(appRouter)}>
              <RouterProvider router={appRouter} future={{ v7_startTransition: true }} />
            </LastLocationManager.Provider>
          </LazyMotion>
        </QueryClientProvider>
        <ToastContainer />
      </>,
    )
  })
